<template>
  <HrPageLayout
    title="New Recruits Approvals"
    subtitle="Employee"
    :breadcrumb-items="[
      { label: 'Home', route: '/dashboard' },
      { label: 'Employee' },
      { label: 'New Recruits Approvals' }
    ]"
  >
    <div class="employee-approvals-new">
      <!-- Stats -->
      <div class="hr-metrics-grid hr-mb-4">
        <div class="hr-metric-card gradient-4">
          <div class="hr-metric-icon">
            <i class="bx bx-time-five"></i>
          </div>
          <div class="hr-metric-content">
              <p class="hr-metric-label">Pending Approvals</p>
          <h3 class="hr-metric-value">{{ approvalStats.pending || 0 }}</h3>
            </div>
        </div>
        <div class="hr-metric-card gradient-2">
          <div class="hr-metric-icon">
            <i class="bx bx-check-circle"></i>
          </div>
          <div class="hr-metric-content">
              <p class="hr-metric-label">Approved Recruits</p>
          <h3 class="hr-metric-value">{{ approvalStats.approved || 0 }}</h3>
            </div>
        </div>
        <div class="hr-metric-card gradient-3">
          <div class="hr-metric-icon">
            <i class="bx bx-x-circle"></i>
          </div>
          <div class="hr-metric-content">
              <p class="hr-metric-label">Rejected Applications</p>
          <h3 class="hr-metric-value">{{ approvalStats.rejected || 0 }}</h3>
            </div>
        </div>
      </div>

      <!-- Notification -->
      <div v-if="message" class="hr-toast hr-toast-bottom-right" @click="message = ''">
        <div class="hr-toast-header" :class="message.includes('success') ? 'hr-toast-success' : 'hr-toast-error'">
          <span class="hr-toast-title">
            {{ message.includes('success') ? 'Success' : 'Error' }}
          </span>
          <button type="button" class="hr-toast-close" @click.stop="message = ''">
            <i class="bx bx-x"></i>
          </button>
        </div>
        <div class="hr-toast-body">
          {{ message }}
        </div>
      </div>

      <!-- Filters + table -->
      <div class="hr-chart-card">
        <div class="hr-chart-header hr-flex hr-justify-between hr-align-center hr-flex-wrap hr-gap-2">
          <div class="hr-search-wrap">
            <div class="hr-search-box">
              <i class="bx bx-search-alt hr-search-icon"></i>
              <input
                type="text"
                class="hr-input hr-input-search"
                placeholder="Search..."
                @input="handleSearch"
              />
            </div>
          </div>
          <div class="hr-flex hr-gap-2 hr-flex-wrap hr-align-center">
            <div class="hr-form-inline-group">
              <label class="hr-form-label hr-mb-0">Department</label>
              <select
                class="hr-select"
                style="min-width: 200px;"
                @change="handleDepartmentChange"
              >
                <option value="">All Departments</option>
                <option
                  v-for="department in departments"
                  :key="department.id"
                  :value="department.id"
                >
                  {{ department.departmentName }}
                </option>
              </select>
            </div>
            <div class="hr-form-inline-group">
              <label class="hr-form-label hr-mb-0">From</label>
              <input
                type="date"
                class="hr-input"
                v-model="dateFrom"
                @change="handleDateChange"
              />
            </div>
            <div class="hr-form-inline-group">
              <label class="hr-form-label hr-mb-0">To</label>
              <input
                type="date"
                class="hr-input"
                v-model="dateTo"
                @change="handleDateChange"
              />
            </div>
            <button
              @click="downloadReport"
              type="button"
              class="hr-btn hr-btn-primary"
            >
              <i class="bx bxs-download"></i>
              Download Report
            </button>
          </div>
        </div>

        <div class="hr-chart-body">
          <div v-if="isLoading" class="hr-loading-wrap">
            <div class="hr-spinner"></div>
            <p>Loading employee data...</p>
          </div>

          <div v-else class="hr-table-wrapper">
            <table class="hr-table hr-table-hover hr-table-bordered hr-table-sm">
              <thead>
                <tr>
                  <th>App No.</th>
                  <th>Name</th>
                  <th>ID No.</th>
                  <th>Contract Type</th>
                  <th>Proposed Salary</th>
                  <th>Department</th>
                  <th>Designation</th>
                  <th>Date Added</th>
                  <th>Submitted By</th>
                  <th class="hr-text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in employeeData" :key="index">
                  <td>{{ item.id }}</td>
                  <td>
                    <button
                      class="hr-link-btn"
                      @click="gotTo(item.id,'employee-approvals-new-verification')"
                    >
                      {{ item.firstName }} {{ item.lastName }}
                    </button>
                  </td>
                  <td>{{ item.nationalId }}</td>
                  <td>{{ item.contractType }}</td>
                  <td>KES {{ item.salary || '0' }}</td>
                  <td>{{ item.department }}</td>
                  <td>{{ item.designation }}</td>
                  <td>{{ item.dateCreated }}</td>
                  <td>{{ item.createdBy }}</td>
                  <td class="hr-text-right">
                    <button
                      class="hr-btn hr-btn-sm hr-btn-success"
                      @click="gotTo(item.id,'employee-approvals-new-verification')"
                    >
                      <i class="bx bx-check-circle"></i>
                      Verify & Approve
                    </button>
                  </td>
                </tr>
                <tr v-if="employeeData.length === 0">
                  <td colspan="10" class="hr-text-center hr-text-muted">
                    No employee records found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>


<script>
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { authUrl, execute, getRight } from "@/api";

export default {
  name: "EmployeeApprovals",
  components: { HrPageLayout },
  data() {
    return {
      alert: {
        success: false,
        info: false,
        failed: false
      },
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      employeeData: [],
      approvalStats: {
        pending: 0,
        approved: 0,
        rejected: 0
      },
      departments: [],
      selectedDepartment: "",
      dateFrom: "",
      dateTo: "",
      searchKeyword: "",
      isLoading: false,
      message: ""
    };
  },
  mounted() {
    // Load departments first, then employee data
    this.getDepartments();
    this.getEmployeeData();
    this.getApprovalStats();
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },
    gotTo(employeeDataId, route) {
      sessionStorage.setItem('employeeDataId', employeeDataId);
      this.$router.push(route);
    },

    // Get list of departments
    getDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.departments)) {
                this.departments = res.data.data.departments;
              } else {
                console.log("No departments data found or incorrect data format");
              }
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // Get aggregated approval statistics (pending / approved / rejected)
    getApprovalStats() {
      const data = new FormData();
      data.append("function", "getEmployeeApprovalStats");

      execute(data, authUrl)
        .then((res) => {
          if (res.data && res.data.success && res.data.data && res.data.data.stats) {
            this.approvalStats = {
              pending: Number(res.data.data.stats.pending) || 0,
              approved: Number(res.data.data.stats.approved) || 0,
              rejected: Number(res.data.data.stats.rejected) || 0
            };
          } else {
            // Keep existing stats but surface any message
            if (res.data && res.data.message) {
              this.message = res.data.message;
            }
          }
        })
        .catch((e) => {
          this.message = e.message || "Failed to fetch approval statistics";
        });
    },

    // Handle department selection change
    handleDepartmentChange(event) {
      this.selectedDepartment = event.target.value;
      this.getEmployeeData();
    },

    // Handle search input
    handleSearch(event) {
      this.searchKeyword = event.target.value;
      this.getEmployeeData();
    },

    // Handle date filter changes
    handleDateChange() {
      this.getEmployeeData();
    },

    // Get employee data with filters
    getEmployeeData() {
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getEmployeeData");

      // Add filters if selected
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      if (this.searchKeyword) {
        data.append("keyword", this.searchKeyword);
      }
      if (this.dateFrom) {
        data.append("dateFrom", this.dateFrom);
      }
      if (this.dateTo) {
        data.append("dateTo", this.dateTo);
      }

      execute(data, authUrl)
          .then((res) => {
            this.isLoading = false;
            console.log("API Response:", res.data); // For debugging

            if (res.data && res.data.success && res.data.data && res.data.data.employeeData) {
              // Map the response data to our display format
              this.employeeData = res.data.data.employeeData.map((item) => {
                // Parse the 'data' field - handle potential JSON parsing errors
                let parsedData = {};
                try {
                  parsedData = item.data ? JSON.parse(item.data) : {};
                } catch (error) {
                  console.error("Error parsing JSON data:", error);
                }

                // Safely access nested properties with fallbacks
                return {
                  id: item.id || "N/A",
                  firstName: (parsedData.employeeData && parsedData.employeeData.firstName) || "N/A",
                  lastName: (parsedData.employeeData && parsedData.employeeData.lastName) || "N/A",
                  nationalId: (parsedData.employeeData && parsedData.employeeData.nationalId) || "N/A",
                  contractType: (parsedData.extraDetails && parsedData.extraDetails.employmentType) || "N/A",
                  salary: (parsedData.bankDetails && parsedData.bankDetails.netSalary) || "0",
                  department: (parsedData.employmentDetails && parsedData.employmentDetails.department) || "N/A",
                  designation: (parsedData.employmentDetails && parsedData.employmentDetails.designation) || "N/A",
                  dateCreated: item.dateCreated || "N/A",
                  createdBy: item.createdBy || "N/A"
                };
              });

              console.log("Processed Employee Data:", this.employeeData); // For debugging
            } else {
              this.message = res.data ? res.data.message || "Failed to get data" : "No response data";
              console.error("API Error:", this.message);
              this.employeeData = [];
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.message = e.message || "An error occurred";
            console.error("API Exception:", e);
            this.employeeData = [];
          });
    },

    // Download report
    downloadReport() {
      const data = new FormData();
      data.append("function", "downloadEmployeeReport");

      // Add filters if selected
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      if (this.searchKeyword) {
        data.append("keyword", this.searchKeyword);
      }
      if (this.dateFrom) {
        data.append("dateFrom", this.dateFrom);
      }
      if (this.dateTo) {
        data.append("dateTo", this.dateTo);
      }

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data.reportUrl) {
              // Open report in new window or initiate download
              window.open(res.data.data.reportUrl, '_blank');
            } else {
              this.message = res.data.message || "Failed to generate report";
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred while generating report";
          });
    }
  }
};
</script>

<style scoped>
@import "@/assets/css/hr-page-shared.css";

.hr-mb-4 {
  margin-bottom: 1.5rem;
}

.hr-search-wrap {
  min-width: 220px;
}

.hr-search-box {
  position: relative;
}

.hr-input-search {
  padding-left: 34px;
}

.hr-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 16px;
}

.hr-form-inline-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hr-toast {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 9999;
  min-width: 260px;
  max-width: 360px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

.hr-toast-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  font-weight: 600;
  color: #ffffff;
}

.hr-toast-success {
  background: linear-gradient(135deg, #16a34a, #22c55e);
}

.hr-toast-error {
  background: linear-gradient(135deg, #dc2626, #f97316);
}

.hr-toast-title {
  font-size: 0.9rem;
}

.hr-toast-close {
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hr-toast-body {
  padding: 10px 14px 12px;
  font-size: 0.9rem;
  color: #334155;
}

.hr-link-btn {
  border: none;
  background: none;
  padding: 0;
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.9rem;
}
</style>

<style scoped>

</style>